export const RESPONSE_SUCCESS = 'success'; // все гуд, пропускаем дальше
export const RESPONSE_EMAIL_NOT_FOUND = 'invalid_email'; // некорректная почта(не нашли)
export const RESPONSE_ERROR = 'error'; // общая ошибка (например капча не прошла)
